import { DEFAULT_LANGUAGE, languages } from '@app/utils/languages';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

interface LanguageSelectorProps {
  language: string;
  handleChangeLanguage(e: React.ChangeEvent<HTMLInputElement>): void;
}

export const LanguageSelector = ({ language, handleChangeLanguage }: LanguageSelectorProps) => {
  return languages.length > 1 ? (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">Language</FormLabel>
      <RadioGroup
        row
        value={language}
        onChange={handleChangeLanguage}
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={DEFAULT_LANGUAGE}
        name="radio-buttons-group">
        {languages.map((lang) => (
          <FormControlLabel key={lang.id} value={lang.key} control={<Radio />} label={lang.label} />
        ))}
      </RadioGroup>
    </FormControl>
  ) : null;
};
